import { CreateHomeDto } from "./create.dto";

export const HomeStatusArray = [
  "Request",
  "Confirming",
  "Doing",
  "Cancel",
  "Done",
  "Reject",
] as const;

export type HomeStatus = typeof HomeStatusArray[number];

export const StatusOption: { [index: string]: string[] } = {
  Request: ["Confirming", "Reject"],
  Confirming: ["Doing", "Reject"],
  Doing: ["Done", "Reject"],
  Cancel: [""],
  Done: [""],
  Reject: [""],
};

export class UpdateHomeDto extends CreateHomeDto {
  id: string;
  isActive?: boolean;
  status?: HomeStatus;

  constructor(params: Partial<CreateHomeDto>) {
    super();
    Object.assign(this, params);
  }
}
